import React, { Component } from 'react'
import { Button,Modal, ModalHeader, ModalBody, ModalFooter,Form,FormGroup,Label } from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';

export default class DeleteConfirmationModel extends Component {

  render() {
    return (
          <Modal isOpen={this.props.isDeleteOpen} toggle={() => this.props.delete_toggle(0)} className="modal-lg">
            <ModalHeader toggle={() => this.props.delete_toggle(0)}>Confirmation</ModalHeader>
            <ModalBody>
            Are you sure to delete this record ?
            </ModalBody>
            <ModalFooter>
            <ActionButton color={"primary"} size={"md"} button_name={"Yes"} button_click={this.props.delete_yes_toggle}/>{' '}
            <ActionButton color={"danger"} size={"md"} button_name={"No"} button_click={() => this.props.delete_toggle(0)}/>
            </ModalFooter>
          </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Models/delete_confirmation_model.js